// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"8d0bdd0d","219":"296b4a7c","455":"399606b7","499":"d76f34d6","783":"e72f0d83","797":"16a6b632","852":"efabf713","977":"8c72bf08"}[chunkId] + ".chunk.js";
};